export const SortType = {
    ASCENDING: 'Ascending',
    DESCENDING: 'Descending',
    ASCENDING_PERCENTAGE: 'Ascending (%)',
    DESCENDING_PERCENTAGE: 'Descending (%)',
    RESET: 'Reset',
}


// WEBPACK FOOTER //
// ./src/app/shared/constants/sort.constants.ts